import { useAnyHoverMediaQuery } from "@circle-react/hooks/useMediaQuery";
import classNames from "classnames";

export interface SpaceGroupNameWrapperProps {
  canManage: boolean;
  children: React.ReactNode;
  isDropdownOpen: boolean;
}

export const SpaceGroupNameWrapper = ({
  isDropdownOpen,
  canManage,
  children,
}: SpaceGroupNameWrapperProps) => {
  const canHover = useAnyHoverMediaQuery();
  // Here width is set to be 100% - width of both icon buttons and also the margin between them and the space group name
  const spaceGroupClass = canManage
    ? "max-w-[calc(100%-56px)]"
    : "max-w-[calc(100%-32px)]";
  const groupHoverClass = canManage
    ? "group-hover:max-w-[calc(100%-56px)]"
    : "group-hover:max-w-[calc(100%-32px)]";

  return (
    <div
      className={classNames("flex w-full space-x-px", {
        [groupHoverClass]: !isDropdownOpen,
        [spaceGroupClass]: isDropdownOpen || !canHover,
      })}
    >
      {children}
    </div>
  );
};
